import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/system";
import { Divider, Typography } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { GetUserById } from "../../helpers/User";
import moment from "moment/moment";
import {
  getFacilityById,
} from "../../helpers/Facilities";
import Toast from "../../components/toast";

export default function ViewFacility() {
  const Navigate = useNavigate();
  const location = useLocation();
  const { facilityId } = location.state || {};
  
    const [facilityDetails, setFacilityDetails] = useState(null);

useEffect(() => {
    if (facilityId) fetchInitialData(facilityId);
  }, [facilityId]);

  const fetchInitialData = async (_facilityId) => {
    const response = await getFacilityById(_facilityId);
    if (response.statusCode === 200 && response.isSuccess === true) {
      const data = response.data;
      setFacilityDetails({
        facilityName: data.facilityName,
        email: data.facilityEmail,
        address: data.facilityAddress,
        city: data.city,
        state: data.state,
        zip: data.zip,
      });
    } else {
      Toast.error(response.message);
    }
  };

  return (
    <>
      <Box mb={3}>
        <Typography
          variant="body2"
          color="primary"
          mb={2}
          sx={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => Navigate("/admin/facility")}
        >
          <KeyboardBackspaceOutlinedIcon
            fontSize="small"
            sx={{ verticalAlign: "middle", mr: 0.5, fontWeight: "medium" }}
          />
          Back to Facilities
        </Typography>

        <Typography variant="h5">Facility Details</Typography>
        <Typography variant="body2" color="text.secondary">
          View the facility’s professional and contact details.
        </Typography>
      </Box>

      <Box
        sx={{
          border: "1px solid #D6D6D6",
          borderRadius: "12px",
          paddingBottom: "15px",
          backgroundColor: "#fff",
          marginBottom: 3,
          overflow: "hidden",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={3}
          paddingX={2}
          paddingY={1.2}
          sx={{
            borderBottom: "solid 1px #D6D6D6",
            backgroundColor: "#FCFCFC",
          }}
        >
          <Typography variant="h6">Professional & Contact Details</Typography>
        </Box>

        <Box paddingX={3}>
          <Grid
            container
            rowSpacing={{ xs: 2, md: 3 }}
            columnSpacing={{ xs: 2, md: 3, lg: 4 }}
          >
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="body2" color="text.secondary">
                Facility Name
              </Typography>
              <Typography variant="body1" color="text.primary" fontWeight="medium">
                {facilityDetails !== null ? facilityDetails.facilityName : ""}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="body2" color="text.secondary">
                Facility Email
              </Typography>
              <Typography variant="body1" color="text.primary" fontWeight="medium">
                {facilityDetails !== null ? facilityDetails.email : ""}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12 }}>
              <Typography variant="body2" color="text.secondary">
                Address
              </Typography>
              <Typography variant="body1" color="text.primary" fontWeight="medium">
                {facilityDetails !== null ? facilityDetails.address : ""}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body2" color="text.secondary">
                City
              </Typography>
              <Typography variant="body1" color="text.primary" fontWeight="medium">
                {facilityDetails !== null ? facilityDetails.city : ""}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body2" color="text.secondary">
                State
              </Typography>
              <Typography variant="body1" color="text.primary" fontWeight="medium">
                {facilityDetails !== null ? facilityDetails.state : ""}
              </Typography>
            </Grid>

            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Zip Code
              </Typography>
              <Typography variant="body1" color="text.primary" fontWeight="medium">
                {facilityDetails !== null ? facilityDetails.zip : ""}
              </Typography>
            </Grid>

          </Grid>

          <Divider sx={{ borderColor: "#E5E7EB", mb: 3, mt: 3 }} />
        </Box>
      </Box>
    </>
  );
}
